import { DicomMetadataStore } from '@ohif/core';
import type { StudyDicomInstance } from './types';

export function resolveStudyInstanceUIDFromViewport(
  viewportId: string,
  servicesManager: AppTypes.ServicesManager
): string | null {
  const { displaySetService, viewportGridService } = servicesManager.services;
  const { viewports } = viewportGridService.getState();
  const viewport = viewports.get(viewportId);
  const displaySetInstanceUID = viewport?.displaySetInstanceUIDs?.[0];

  if (!displaySetInstanceUID) {
    return null;
  }

  const displaySet = displaySetService.getDisplaySetByUID(displaySetInstanceUID);
  return displaySet?.StudyInstanceUID ?? null;
}

export function collectStudyDicomInstances(studyInstanceUID: string): StudyDicomInstance[] {
  const study = DicomMetadataStore.getStudy(studyInstanceUID);

  if (!study?.series?.length) {
    return [];
  }

  const instances: StudyDicomInstance[] = [];

  study.series.forEach(series => {
    series.instances?.forEach(instance => {
      if (instance?.SOPInstanceUID) {
        instances.push(instance as StudyDicomInstance);
      }
    });
  });

  return instances;
}
